/** Normalize tracking_status API payload to a list of timeline rows. */
export function trackingEntriesFromApiResponse(res) {
  const root = res?.data ?? res;
  if (Array.isArray(root)) return root;
  if (root && typeof root === 'object') {
    for (const key of [
      'data',
      'tracking_status',
      'tracking',
      'complaint_comments',
      'comments',
      'history',
      'items',
    ]) {
      if (Array.isArray(root[key])) return root[key];
    }
  }
  return [];
}

export function trackingEntryDate(entry) {
  const v = entry?.created_at ?? entry?.date ?? entry?.updated_at ?? entry?.timestamp;
  if (!v) return '—';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}

export function trackingEntryComment(entry) {
  const v = entry?.comment ?? entry?.remarks ?? entry?.description ?? entry?.note;
  return v != null && String(v).trim() !== '' ? String(v).trim() : '';
}

/** `completed` = before active step, `current` = active: true, `upcoming` = after. */
export function trackingStepPhase(entries, index) {
  if (!Array.isArray(entries) || index < 0 || index >= entries.length) return 'upcoming';
  const activeIndex = entries.findIndex((e) => e?.active === true);
  if (activeIndex < 0) {
    const hasActivity = entries[index]?.created_at != null && String(entries[index].created_at) !== '';
    return hasActivity ? 'completed' : 'upcoming';
  }
  if (index < activeIndex) return 'completed';
  if (index === activeIndex) return 'current';
  return 'upcoming';
}
